<div class="skeleton-loader" *ngIf="statusDetail == 'loading'">
  <div
    class="charging-content"
    *ngFor="let item of [0, 1, 2, 3, 4, 5, 6]"
  ></div>
</div>

<div *ngIf="statusDetail == 'success'">
  <div *ngIf="dataSource.data && dataSource.data.length; else noMatches">
    <table class mat-table [dataSource]="dataSource">
      <ng-container matColumnDef="Nombre">
        <th
          class="name-header alt-inter-semibold alt-size-14"
          mat-header-cell
          *matHeaderCellDef
        >
          <div class="title-container alt-row-align-center">
            <p class="title_inside">{{ "ORGANIZATION.name" | translate }}</p>
            <div class="order-arrows alt-column-justify-center">
              <mat-icon
                class="up-order pointer"
                (click)="sortByName()"
                svgIcon="arrow"
              ></mat-icon>
              <mat-icon
                class="down-order pointer"
                (click)="sortByDownName()"
                svgIcon="arrow"
              ></mat-icon>
            </div>
          </div>
        </th>
        <td
          class="name-column alt-inter-medium alt-size-14"
          mat-cell
          *matCellDef="let element"
          (click)="goToDetails(element.company._id)"
        >
          <div class="column1-container alt-flex-row">
            <div class="image-profile">
              <img
                [src]="
                  element.company.picture_profile ?? 'assets/icons/CatUser.svg'
                "
              />
            </div>
            <div class="info-colum1 alt-flex-column">
              <p class="company-names alt-size-14 alt-inter-medium">
                {{ element.company.names }} {{ element.company.surnames }}
              </p>
              <div class="info-container alt-row-align-center">
                <div *ngFor="let flag of flags">
                  <mat-icon
                    class="country-flag"
                    *ngIf="element.company.country === flag.option2"
                    [svgIcon]="flag.flag"
                  ></mat-icon>
                </div>
                <p class="country-name alt-size-12 alt-inter-medium">
                  {{ element.company.country }}
                </p>
              </div>
            </div>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="Teléfono">
        <th
          class="phone-header alt-inter-semibold alt-size-14"
          mat-header-cell
          *matHeaderCellDef
        >
          <p class="title_inside">
            {{ "FACILITATOR.phone-number" | translate }}
          </p>
        </th>
        <td
          class="phone-column alt-inter-medium alt-size-14"
          mat-cell
          *matCellDef="let element"
        >
          <div class="info-colum1 alt-flex-column">
            <div class="info-container alt-justify-center alt-size-16">
              <div class="" *ngFor="let flag of flags">
                <p
                  class="country-code alt-size-14"
                  *ngIf="element.company.country === flag.option2"
                >
                  {{ flag.country_code }}
                </p>
              </div>
              <p class="country-name alt-size-14">
                {{ element.company.telephone }}
              </p>
            </div>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="Bussines">
        <th
          class="busines-header alt-inter-semibold alt-size-14"
          mat-header-cell
          *matHeaderCellDef
        >
          <div class="title-container alt-row-align-center">
            <p class="title_inside">{{ "ORGANIZATION.bns" | translate }}</p>
            <div class="order-arrows alt-column-justify-center">
              <mat-icon
                class="up-order pointer"
                (click)="sortByBussines()"
                svgIcon="arrow"
              ></mat-icon>
              <mat-icon
                class="down-order pointer"
                (click)="sortByDownBussines()"
                svgIcon="arrow"
              ></mat-icon>
            </div>
          </div>
        </th>
        <td
          class="busines-column alt-inter-medium alt-size-14"
          mat-cell
          *matCellDef="let element"
        >
          <div
            class="bussines-info-container alt-justify-center"
            *ngIf="
              element.company.company_name != undefined &&
                element.company.selling;
              else justPreRegistered
            "
          >
            <p
              class="bussines-name alt-inter-medium alt-size-12 alt-color-grayscale1"
            >
              {{ element.company.company_name }}
            </p>
            <p
              class="bussines-categorie alt-inter-normal alt-size-12 alt-color-grayscale2"
            >
              ({{ validateTypeBussinesCompanie(element.company) | titlecase }})
            </p>
          </div>

          <ng-template #justPreRegistered>
            <p>--:--</p>
          </ng-template>
        </td>
      </ng-container>

      <ng-container matColumnDef="challenge-on">
        <th
          class="challenge-header alt-inter-semibold alt-size-14"
          mat-header-cell
          *matHeaderCellDef
        >
          {{ "ORGANIZATION.challenge-on" | translate }}
        </th>
        <td
          class="challenge-column alt-inter-medium alt-size-14"
          mat-cell
          *matCellDef="let element"
        >
          <div>
            <p *ngIf="element.challenge_in_progress; else justPreRegistered">
              {{ "CHALLENGES.challengeText" | translate }}
              {{ element.challenge_in_progress.number_challenge }}:
              <span>{{
                element.challenge_in_progress.name_challenge | format
              }}</span>
            </p>
            <ng-template #justPreRegistered>
              <p>--:--</p>
            </ng-template>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="activity">
        <th
          class="challenge-header alt-inter-semibold alt-size-14"
          mat-header-cell
          *matHeaderCellDef
        >
          {{ "CHALLENGES.activityOn" | translate }}
        </th>
        <td
          class="challenge-column alt-inter-medium alt-size-14"
          mat-cell
          *matCellDef="let element"
        >
          <div>
            <p *ngIf="element.challenge_in_progress; else justPreRegistered">
              {{ "CHALLENGES.activity" | translate }}
              {{ element.challenge_in_progress.activity.number_activity }}:
              <span>{{
                element.challenge_in_progress.activity.name_activity | format
              }}</span>
            </p>
            <ng-template #justPreRegistered>
              <p>--:--</p>
            </ng-template>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th
          class="state-header alt-inter-semibold alt-size-14"
          mat-header-cell
          *matHeaderCellDef
        >
          {{ "DASHBOARD.status" | translate }}
        </th>
        <td
          class="state-column alt-inter-medium alt-size-14"
          mat-cell
          *matCellDef="let element"
        >
          <div [class]="'status-container' + ' ' + element.company.status">
            <p class="status-text alt-inter-semibold alt-size-10">
              {{ statusText(element.company.status) | translate | uppercase }}
            </p>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr
        class="pointer"
        mat-row
        *matRowDef="let row; columns: displayedColumns"
      ></tr>
    </table>

    <mat-paginator
      (page)="handlePageEvent($event)"
      [pageSize]="size"
      [length]="totalItems"
      [pageIndex]="page - 1"
      aria-label="Select page of periodic elements"
      >></mat-paginator
    >
  </div>

  <ng-template #noMatches>
    <div *ngIf="companyList" class="container-matches">
      <app-no-matches></app-no-matches>
    </div>
  </ng-template>
</div>

<!-- //TODO VERIFY THIS IMPLEMENTATION -->
<!-- <div
  *ngIf="statusDetail == 'success' && validator == 0"
  class="container-matches"
>
  <div class="no-users-created alt-justify-center">
    <mat-icon class="image-no-data" svgIcon="noDataList"></mat-icon>
  </div>
  <p
    class="text-info-no-users alt-color-grayscale1 alt-size-14 alt-inter-semibold"
  >
    {{ "USERS.noDataText" | translate }}
    {{ "ORGANIZATION.pre-register" | translate | lowercase }}
  </p>
</div> -->
